import { CoachMark } from "@hatch-digital-nl/bravilor-storybook";
import { ReactComponent as RefreshIcon } from "../../../common/svgs/cycle.svg";
import { JSX } from "react";
import { useRefurbishedPage } from "../hooks/useRefurbishedPage";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

export const ExplanationModal = (): JSX.Element | null => {
    const { refurbishedState, handleCloseCoachMark } = useRefurbishedPage();
    const { t, isLoading: translationsIsLoading } = useStringTranslation();

    if (!refurbishedState.isCoachMarkVisible) return null;

    return (
        <CoachMark
            className={"p-refurbished__coachmark"}
            isLoading={translationsIsLoading}
            title={t("what-does-refurbished-mean-title")}
            description={t("what-does-refurbished-mean-description")}
            buttonLabel={t("got-it")}
            onClose={handleCloseCoachMark}
            onButtonClick={handleCloseCoachMark}
            Icon={RefreshIcon}
        />
    );
};
